import { render } from "./EventDetail.vue?vue&type=template&id=218b70e5&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"

import "./EventDetail.vue?vue&type=style&index=0&id=218b70e5&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_omnia_1776687441006616365/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218b70e5"]])

export default __exports__